module.exports = __webpack_public_path__ + "img/ppr-footer-border-accent.eabb95b4.svg";